import { IInteractiveState, IMeta } from '@bees-web/core/types'
import { AnyAction } from 'redux'
import { ThunkDispatch } from 'redux-thunk'
import {
  trackCategoryTileClickedSegmentsViewed,
  trackContentLoaded,
  trackMainCategoryTileViewed,
} from '../actions/categories'
import { IHomeState } from '../interfaces'

export const categoryTileClickedSegments = (
  meta: IMeta,
  dispatch: ThunkDispatch<IInteractiveState<IHomeState>, {}, AnyAction>
) => {
  const {
    position,
    referrer,
    screen_name,
    store_id,
    tile_name,
    value_stream,
    vendor_list,
  } = meta
  dispatch(
    trackCategoryTileClickedSegmentsViewed({
      position,
      referrer,
      screen_name,
      store_id,
      tile_name,
      value_stream,
      vendor_list,
    })
  )
}

export const categoryTileViewedSegments = (
  meta: IMeta,
  dispatch: ThunkDispatch<IInteractiveState<IHomeState>, {}, AnyAction>
) => {
  const {
    category_tile_list,
    referrer,
    screen_name,
    store_id,
    value_stream = 'HOMEPAGE',
  } = meta
  dispatch(
    trackMainCategoryTileViewed({
      referrer,
      screen_name,
      store_id,
      value_stream,
      category_tile_list,
    })
  )
}

export const categoryContentLoadedSegments = (
  meta: IMeta,
  dispatch: ThunkDispatch<IInteractiveState<IHomeState>, {}, AnyAction>
) => {
  const { referrer, screen_name, store_id, value_stream, section_name } = meta
  dispatch(
    trackContentLoaded({
      screen_name,
      value_stream,
      section_name,
      store_id,
      referrer,
    })
  )
}
